import { Placeholder } from "semantic-ui-react";
import PropTypes from "prop-types";
import { isString } from "lodash";

import { CloseButton } from "../../buttons/closeButton";

import "./modalHeader.scss";

const displayTitle = (title, loading) => {
  return isString(title) && !loading ? (
    <span className="title-text">{title}</span>
  ) : (
    <Placeholder data-testid="loading-modal-header">
      <Placeholder.Header />
    </Placeholder>
  );
};

function ModalHeader(props) {
  const { title, onClose, loading } = props;
  return (
    <div className="modal-header">
      {title ? displayTitle(title, loading) : <div />}

      <CloseButton onClick={onClose} className="close-button" />
    </div>
  );
}

ModalHeader.propTypes = {
  title: PropTypes.any,
  onClose: PropTypes.func,
  loading: PropTypes.bool,
};

export default ModalHeader;
